<template>
    <v-card v-if="segment" class="fill-height" :loading="loading">
        <v-card-title>Segment {{ segment.name }}</v-card-title>
        <!--
        <v-card-text>
            TODO create/view form
            TODO campaigns for segment
        </v-card-text>
        -->
        <v-list>
            <v-list-item id="pfid1657208744">
                <v-list-item-icon><v-icon>$segment</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('contacts.tags.recipients')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ visitorsCache[segment.id] == null ? $t('common.notLoaded') : visitorsCache[segment.id] }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <action-button :tooltip="$t('common.refresh')"  
                    @click="loadVisitors"
                    :loading="rv" 
                    icon="$refresh" />
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-if="form" id="pfid1657208725" >
                <v-list-item-icon><v-icon>$form</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('contacts.form.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{form.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <action-button :tooltip="$t('dialog.edit')"  
                    :to="{ name: form, params: { form: form.id }}"
                     />
                </v-list-item-action>
              </v-list-item>
              
              <v-subheader>{{$t('overview.tasks.title')}}</v-subheader>
            <v-list-item id="pfid1618852918" :to="{ name: 'contacts-c-import', params: {segment: segment.id }}">
                        <v-list-item-icon>
                            <v-icon>$importCustomers</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('overview.tasks.customers')}}</v-list-item-title>
                        </v-list-item-content>
            </v-list-item>
            <v-list-item id="pfid1619469269"  :to="{ name: 'contacts-o-import', params: {segment: segment.id }}">
                        <v-list-item-icon>
                            <v-icon>$importOrders</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('overview.tasks.orders')}}</v-list-item-title>
                        </v-list-item-content>
            </v-list-item>
            <v-list-item id="pfid1657287783" :to="{ name: 'add-campaign', query: {tagId: segment.id }}">
                        <v-list-item-icon>
                            <v-icon>$campaign</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('contacts.tags.addCampaign')}}</v-list-item-title>
                        </v-list-item-content>
            </v-list-item>
            <v-list-item id="pfid1657208816" v-if="!form"  :to="{ name: 'add-form', params: { segment: segment.id }}">
                        <v-list-item-icon>
                            <v-icon>$form</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('contacts.tags.addForm')}}</v-list-item-title>
                        </v-list-item-content>
            </v-list-item>
            
        </v-list>
        <v-card-subtitle>{{$t('campaigns.title')}}</v-card-subtitle>
        <v-card-text v-if="campaignsUsed && campaignsUsed.length > 0">
        <v-chip color="info"  outlined v-for="c in campaignsUsed" :key="c.id" class="mx-1 mb-1" :to="{name: 'campaign-detail', params: { campaign: c.id}}">{{c.name}}</v-chip>
        </v-card-text>
        <v-card-text v-else-if="campaignsUsed && campaignsUsed.length == 0">
            <p class="text-center">{{ $t('contacts.tags.noCampaigns')}}</p>
        </v-card-text>
        <v-card-text v-else>
             <v-row justify="start" no-gutters>
                <v-skeleton-loader v-for="i in 8" :key="i" class="mx-1 mb-1" type="chip" />
             </v-row>
        </v-card-text>
        <!--
        <v-card-actions>
            <v-btn text :to="{ name: 'contacts-c-import', params: {segment: segment.id }}"><v-icon left>$importCustomers</v-icon>{{$t('overview.tasks.customers')}}</v-btn>
            <v-btn text :to="{ name: 'contacts-o-import', params: {segment: segment.id }}"><v-icon left>$importOrders</v-icon>{{$t('overview.tasks.orders')}}</v-btn>
        </v-card-actions>
        -->
    </v-card>
    <v-skeleton-loader v-else type="card" />
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'Segment',
    data() {
        return {
            rv: false,
            rc: false,
            rf: false
        }
    },
    computed: {
        segment() {
            return this.tags?.find(t => t.id == this.$route.params.segment)
        },
        campaignsUsed() {
            return this.campaigns?.filter(c => c.segment?.tagId == this.segment.id)
        },
        form() {
            return this.forms?.find(f => f.tagID == this.segment.id)
        },
        loading() {
            return this.rv || this.rc || this.rf;
        },
        ...mapState('contacts', ['tags','visitorsCache']),
        ...mapState('campaigns', {campaigns: 'list'}),
        ...mapState('forms', {forms: 'list'}),
    },
    methods: {
        async loadVisitors() {
            this.rv = true;
            await this.$store.dispatch('contacts/loadVisitors', { id: this.segment.id });
            this.rv = false;
        },
        loadCampaigns() {
          if (!this.campaigns) {
            this.refreshCampaigns();
          }
        },
        loadForms() {
            if(!this.forms) {
                this.refreshForms();
            }
        },
        async refreshForms() {
            this.rf = true;
            await this.$store.dispatch("forms/list", { domainID: this.$route.params.domain });
            this.rf = false;
        },
        async refreshCampaigns() {
          this.rc = true;
          await this.$store.dispatch("campaigns/list", { domainID: this.$route.params.domain, sortDirection: 'DESC' });
          this.rc = false;
        },
    },
    created() {
        this.loadCampaigns();
        this.loadForms();
    }
   
}
</script>

<style>

</style>